import {
  IsIn,
  IsNotEmpty,
  IsNumber,
  IsString,
  Min,
  MinLength,
  Validate,
  ValidatorConstraint,
} from "class-validator";
import type {
  ValidatorConstraintInterface,
  ValidationArguments,
} from "class-validator";

@ValidatorConstraint({ name: "discountSplitSum", async: false })
class DiscountSplitSumConstraint implements ValidatorConstraintInterface {
  validate(_value: unknown, args: ValidationArguments): boolean {
    const obj = args.object as DiscountFormDto;
    return obj.platform_percent + obj.sto_percent === 100;
  }

  defaultMessage(): string {
    return "Сумма долей платформы и СТО должна быть равна 100%";
  }
}

export class DiscountFormDto {
  @IsString()
  @IsNotEmpty({ message: "Укажите название" })
  @MinLength(2, { message: "Минимум 2 символа" })
  title = "";

  @IsIn(["manual", "promocode"])
  type: "manual" | "promocode" = "manual";

  @IsIn(["percent", "fixed"])
  value_type: "percent" | "fixed" = "percent";

  @IsNumber({}, { message: "Укажите размер скидки" })
  @Min(1, { message: "Размер скидки должен быть больше 0" })
  value = 10;

  @IsNumber()
  platform_percent = 50;

  @IsNumber()
  sto_percent = 50;

  @Validate(DiscountSplitSumConstraint)
  splitSumMarker = true;
}
